import React from 'react'
// ##
import SubCategoriesTable from '../../modules/SubCategory/components/SubCategoriesTable'

export default function SectionPage() {
  return <SubCategoriesTable />
}
